import React, { useEffect, useState } from "react";

const QuestionTimer = ({ duration, onTimeUp }) => {
  const [secondsLeft, setSecondsLeft] = useState(duration);

  useEffect(() => {
    if (secondsLeft <= 0) {
      onTimeUp?.();
      return;
    }

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60)
      .toString()
      .padStart(2, "0");
    const s = (sec % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <div className="text-sm text-gray-700 font-semibold bg-gray-100 px-3 py-1 rounded-md">
      ⏳ زمان باقی‌مانده: {formatTime(secondsLeft)}
    </div>
  );
};

export default QuestionTimer;
